import React from 'react';
import {
    PanelHeader,
    Div,

    SplitCol,
    SplitLayout,
    Button,
    ButtonGroup,

    ModalRoot,
    ModalPage,
    ModalPageHeader,
    PanelHeaderButton,
    FormItem,
    Textarea,
    Accordion
} from '@vkontakte/vkui';


import {AdaptivityContext, setQuizStep} from "../assets/constants";

import BaseComponent from "../components/BaseComponent";
import BaseApi from "../api/BaseApi";


import * as constants from "../assets/constants";
import {Icon24Cancel, Icon24Done} from "@vkontakte/icons";
import SummaryList from "./SummaryList";


class FacingMonitoringStep3 extends BaseComponent {

    state = {
        loading: false,
        prevDoc: null,
        items_values: {},
        typesLabels: {},
        currentType: constants.CODE_FACING_MONITORING_TYPE_PART,
        currentDivision: null,
        docComment: this.props.current_doc && this.props.current_doc.doc_data ? this.props.current_doc.doc_data.comment : ''
    }

    constructor(props) {
        super(props);

        const savedType = localStorage.getItem(constants.current_facing_monitoring_type_key)
        const savedJsonDivision = localStorage.getItem(constants.current_facing_monitoring_division_key)

        if (this.props.current_doc && this.props.current_doc.doc_data) {
            this.state.currentType = this.props.current_doc.doc_data.type_
            this.state.currentDivision = {
                id: this.props.current_doc.doc_data.division_id,
                name: this.props.current_doc.doc_data.division_name
            }
        } else {
            if (savedType) {
                this.state.currentType = savedType
            }
            if (savedJsonDivision) {
                try {
                    this.state.currentDivision = JSON.parse(savedJsonDivision)
                } catch (e) {

                }
            }
        }
        this.state.typesLabels = constants.getFacingMonitoringTypes()
        delete this.state.typesLabels['']
    }

    getPrevDoc = () => {

        this.setState({prevDoc: null})
        let division_id = this.props.current_user.meta.division ? this.props.current_user.meta.division.code : ''
        const doc_id = this.props.current_doc && this.props.current_doc.doc_data ? this.props.current_doc.doc_data.id : null

        if (this.props.current_doc && this.props.current_doc.doc_data) {
            division_id = this.props.current_doc.doc_data.division_id
        }

        const ids = Object.keys(this.state.items_values)


        BaseApi.post(`?app=FacingMonitoring&act=getPrevDoc`, {
                division_id,
                doc_id,
                ids: ids.length > 0 ? JSON.stringify(ids) : ''
            }
        ).then((response) => {

            if (response.data.prevDoc) {
                this.setState({prevDoc: response.data.prevDoc})

                if (response.data.newItems && response.data.newItems.results && Array.isArray(response.data.newItems.results)) {

                    const olds = this.state.items_values
                    response.data.newItems.results.map((item) => {
                        olds[item.id].name = item.name
                    })
                    this.setState({items_values: olds})
                }

            }


        }).catch(() => {
            this.setState({prevDoc: null})
        })

    }

    componentDidMount() {
        super.componentDidMount()
        const data = localStorage.getItem(constants.values_facing_monitoring_key)

        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            this.setState({items_values: items})
        }
        if (this.state.currentType == constants.CODE_FACING_MONITORING_TYPE_FULL) {
            setTimeout(() => this.getPrevDoc(), 500)
        }
    }

    receiveMessage = (event) => {


    }


    render() {
        const images_url = this.props.base_url.replace("frontend/", '')
        const newCnt = {}
        const foundCnt = {}
        const notFoundCnt = {}
        const {prevDoc, items_values} = this.state
        const prev_items_values = prevDoc ? prevDoc.items_values : null
        Object.keys(items_values).map((id) => {
            if (!prev_items_values || !prev_items_values[id]) {
                newCnt[id] = items_values[id]
            }
        })
        if (prev_items_values) {


            Object.keys(prev_items_values).map((id) => {
                if (!items_values[id]) {
                    notFoundCnt[id] = prev_items_values[id]
                } else {
                    foundCnt[id] = prev_items_values[id]
                    foundCnt[id].qnt = items_values[id].qnt
                }
            })
        }


        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>

                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_SEND_ORDER}
                           onClose={this.modalBack}

                           style={{
                               width: "100%", marginBottom: "100px"
                           }}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton
                                       onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   Завершение мониторинга витрины
                               </ModalPageHeader>
                           }
                >
                    <Div>Завершить мониторинг витрины?</Div>
                    <FormItem top="Комментарий">
                        <Textarea autoFocus value={this.state.docComment} rows={7} placeholder="Можно оставить пустым"
                                  onChange={e => this.setState({docComment: e.currentTarget.value})}/>
                    </FormItem>
                    <Div style={{marginBottom: '100px'}}>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button before={<Icon24Done/>} size="l" stretched disabled={this.state.loading}
                                    loading={this.state.loading}
                                    onClick={() => this.sendDoc()}>Да</Button>
                            <Button before={<Icon24Cancel/>} size="l" stretched disabled={this.state.loading}
                                    onClick={() => this.setActiveModal(null)}>Нет</Button>
                        </ButtonGroup>
                    </Div>
                </ModalPage>
            </ModalRoot>

        );
        return (
            <div>
                <SplitLayout modal={modals}>
                    <SplitCol>
                        <PanelHeader fixed={true}>
                            <Div>
                                Итоги
                            </Div>
                        </PanelHeader>

                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Мониторинг витрины завершен. Ниже итоги. Можно фильтрами проверить товары. Нажмите завершить
                        </Div>
                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Тип инвентаризации: {this.state.typesLabels[this.state.currentType]}
                        </Div>
                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Подразделение: {this.state.currentDivision ? this.state.currentDivision.name : "Без подразделения"}
                        </Div>
                    </SplitCol>
                </SplitLayout>
                {prevDoc && prevDoc.doc_data && <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Последний документ: {prevDoc.doc_data.nomer} от {prevDoc.doc_data.date}
                        </Div>
                    </SplitCol>
                </SplitLayout>}

                <SplitLayout>
                    <SplitCol>
                        <Accordion className="summary-element">
                            <Accordion.Summary>{this.state.currentType == constants.CODE_FACING_MONITORING_TYPE_FULL?'Новые позиции':'Найденные позиции'}: {Object.keys(newCnt).length}</Accordion.Summary>
                            <SummaryList list={newCnt}/>
                        </Accordion>
                    </SplitCol>
                </SplitLayout>
                {this.state.currentType == constants.CODE_FACING_MONITORING_TYPE_FULL && <SplitLayout>
                    <SplitCol>
                        <Accordion className="summary-element">
                            <Accordion.Summary>Не нашли: {Object.keys(notFoundCnt).length}</Accordion.Summary>
                            <SummaryList list={notFoundCnt}/>
                        </Accordion>
                    </SplitCol>
                </SplitLayout>}
                {this.state.currentType == constants.CODE_FACING_MONITORING_TYPE_FULL && <SplitLayout>
                    <SplitCol>
                        <Accordion className="summary-element" style={{marginBottom: '150px'}}>
                            <Accordion.Summary>Нашли: {Object.keys(foundCnt).length}</Accordion.Summary>
                            <SummaryList list={foundCnt}/>
                        </Accordion>
                    </SplitCol>
                </SplitLayout>}
                <SplitLayout>
                    <SplitCol>
                        <Div className="action-board">
                            <ButtonGroup mode="horizontal" stretched>
                                <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                        onClick={() => setQuizStep(2, 'FacingMonitoring')}>Назад</Button>
                                <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                        onClick={() => this.setActiveModal(constants.MODAL_SEND_ORDER)}
                                >Завершить</Button>
                            </ButtonGroup>
                        </Div>
                    </SplitCol>
                </SplitLayout>
            </div>
        )
    }

    sendDoc = () => {
        const images_url = this.props.images_url

        let errors = 0

        const products = []

        const items = this.state.items_values
        const keys = Object.keys(items)
        keys.map((key) => {

            const item = items[key]

            const newItem = {product_id: key, quantity: item.qnt ?? 0}

            products.push(newItem)

        })
        if (products.length == 0) {
            window.postMessage({type: 'error', text: 'Документ пустой! Добавьте хотя бы одну позицию!'})
            errors++
        }

        if (errors > 0) {
            return
        }

        const document_ = {
            date: new Date(),
            comment: this.state.docComment,
            type: this.state.currentType,
            division: this.state.currentDivision,
            products: products
        }


        console.log(JSON.stringify(document_))


        const data_send = {body: JSON.stringify(document_)}


        if (this.props.current_doc && this.props.current_doc.doc_data) {
            data_send['doc_id'] = this.props.current_doc.doc_data.id
        }

        BaseApi.post('/?app=facingMonitoring&act=saveDoc', data_send,
        ).then((response) => {
            this.setActiveModal(null)
            window.postMessage({type: 'endFacingMonitoring'})
        })

    }


}

export default FacingMonitoringStep3